import {
  SalesReport,
  salesReportFromResponse,
} from '../SalesReport/SalesReport';

export interface CustomerOrdersReport extends SalesReport {
  customerName: string;
  email: string;
  companyName?: string;
}

export const customerOrdersReportFromResponse = (
  responseData: any,
): CustomerOrdersReport => ({
  ...salesReportFromResponse(responseData),
  customerName: responseData.customer_name,
  email: responseData.email,
  companyName: responseData.company_name,
});
